"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _xstate = require("xstate");
var _propTypes = require("prop-types");
var _DirectBook = _interopRequireDefault(require("./DirectBook"));
var _Actions = require("../../lib/constants/Actions");
var _thirdPartyLogin = require("../../lib/constants/thirdPartyLogin");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class DirectBookContainer extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleMachineTransition", currentState => {
      this.setState({
        currentState
      });
      this.props.logState(currentState);
    });
    (0, _defineProperty2.default)(this, "handleGoBack", step => {
      this.service.send({
        type: _Actions.GO_BACK,
        data: {
          step
        }
      });
    });
    this.state = {
      currentState: props.machine.initialState
    };
    this.service = (0, _xstate.interpret)(props.machine).onTransition(this.handleMachineTransition);
  }
  componentDidMount() {
    this.service.start();
    this.service.send(_Actions.INITIALIZED);
  }
  componentWillUnmount() {
    this.service.stop();
  }
  render() {
    const {
      currentState
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_DirectBook.default, {
      onGoBack: this.handleGoBack,
      currentState: currentState,
      mapApiKey: this.props.mapApiKey,
      awsMapConfig: this.props.awsMapConfig,
      thirdPartyLoginProps: this.props.thirdPartyLoginProps,
      config: this.props.config,
      track: this.props.track,
      history: this.props.history,
      apptDensity: this.props.apptDensity,
      apptPurposeFilterProps: this.props.apptPurposeFilterProps,
      onScroll: this.props.onScroll
    });
  }
}
(0, _defineProperty2.default)(DirectBookContainer, "propTypes", {
  /* eslint-disable react/forbid-prop-types */
  config: _propTypes.object.isRequired,
  machine: (0, _propTypes.instanceOf)(_xstate.StateNode).isRequired,
  track: _propTypes.func.isRequired,
  mapApiKey: _propTypes.string,
  awsMapConfig: _propTypes.object,
  thirdPartyLoginProps: (0, _propTypes.shape)({
    type: (0, _propTypes.oneOf)(['mychart']).isRequired,
    isLoggedIn: _propTypes.bool.isRequired,
    login: (0, _propTypes.shape)({
      url: _propTypes.string,
      callback: _propTypes.func.isRequired
    }).isRequired,
    logout: (0, _propTypes.shape)({
      url: _propTypes.string,
      callback: _propTypes.func.isRequired
    }).isRequired,
    errors: (0, _propTypes.arrayOf)((0, _propTypes.oneOf)((0, _values.default)(_thirdPartyLogin.ERROR)))
  }),
  logState: _propTypes.func,
  /* optional react-router history object for db-widget to control url and forward/back */
  history: (0, _propTypes.shape)({
    push: _propTypes.func,
    replace: _propTypes.func,
    location: (0, _propTypes.shape)({
      pathname: _propTypes.string,
      search: _propTypes.string
    })
  }),
  apptDensity: (0, _propTypes.oneOf)(['default', 'dense']),
  /* Properties for the appointment purpose filter controls */
  apptPurposeFilterProps: (0, _propTypes.shape)({
    /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
    minPurposesForFilter: _propTypes.number,
    /* Labels for rendering the filter controls */
    labels: (0, _propTypes.shape)({
      noResultsLabel: _propTypes.string,
      purposeSearchLabel: _propTypes.string,
      purposeSearchPlaceholderLabel: _propTypes.string,
      visitTypeAllLabel: _propTypes.string,
      visitTypeInPersonLabel: _propTypes.string,
      visitTypeVirtualLabel: _propTypes.string
    }),
    /* Function executed when the name filter changes */
    onNameFilterChange: _propTypes.func,
    /* Function executed when the visit type filter changes */
    onVisitTypeFilterChange: _propTypes.func,
    /* Function executed when the filters are cleared */
    onClearFilters: _propTypes.func
  }),
  onScroll: _propTypes.func
});
(0, _defineProperty2.default)(DirectBookContainer, "defaultProps", {
  mapApiKey: '',
  logState: () => {},
  history: null
});
var _default = exports.default = DirectBookContainer;
DirectBookContainer.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleMachineTransition",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "currentState",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleGoBack",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "step",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "DirectBookContainer",
  "props": {
    "mapApiKey": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "logState": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "history": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "push": {
            "name": "func",
            "required": false
          },
          "replace": {
            "name": "func",
            "required": false
          },
          "location": {
            "name": "shape",
            "value": {
              "pathname": {
                "name": "string",
                "required": false
              },
              "search": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false
    },
    "config": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "machine": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "StateNode"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "awsMapConfig": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "thirdPartyLoginProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "type": {
            "name": "enum",
            "value": [{
              "value": "'mychart'",
              "computed": false
            }],
            "required": true
          },
          "isLoggedIn": {
            "name": "bool",
            "required": true
          },
          "login": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "required": false
              },
              "callback": {
                "name": "func",
                "required": true
              }
            },
            "required": true
          },
          "logout": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "required": false
              },
              "callback": {
                "name": "func",
                "required": true
              }
            },
            "required": true
          },
          "errors": {
            "name": "arrayOf",
            "value": {
              "name": "enum",
              "computed": true,
              "value": "Object.values(THIRD_PARTY_LOGIN_ERROR)"
            },
            "required": false
          }
        }
      },
      "required": false
    },
    "apptDensity": {
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'default'",
          "computed": false
        }, {
          "value": "'dense'",
          "computed": false
        }]
      },
      "required": false
    },
    "apptPurposeFilterProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "minPurposesForFilter": {
            "name": "number",
            "required": false
          },
          "labels": {
            "name": "shape",
            "value": {
              "noResultsLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchPlaceholderLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeAllLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeInPersonLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeVirtualLabel": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "onNameFilterChange": {
            "name": "func",
            "required": false
          },
          "onVisitTypeFilterChange": {
            "name": "func",
            "required": false
          },
          "onClearFilters": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": false
    },
    "onScroll": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};